import React, { useEffect, useState } from 'react'

const CookiePopup: React.FC = () => {
  const [showPopup, setShowPopup] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [performanceChecked, setPerformanceChecked] = useState(false)
  const [advertisingChecked, setAdvertisingChecked] = useState(false)

  // Fonctions cookies
  const setCookie = (name: string, value: string | boolean, days: number) => {
    const d = new Date()
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000)
    document.cookie = `${name}=${value};path=/;expires=${d.toUTCString()};SameSite=Lax`
  }

  const getCookie = (name: string): string | null => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
    if (match) return match[2]
    return null
  }

  // Vérifier si l'utilisateur a déjà fait un choix
  useEffect(() => {
    if (!getCookie('voyo_cookies_decision')) {
      setShowPopup(true)
    }
  }, [])

  // Charger les préférences existantes
  useEffect(() => {
    const perf = getCookie('voyo_cookies_performance')
    const adv = getCookie('voyo_cookies_advertising')
    if (perf === 'true') setPerformanceChecked(true)
    if (adv === 'true') setAdvertisingChecked(true)
  }, [])

  // Déclarer gtag en dehors de la fonction
  const gtag = (...args: any[]) => {
    ;(window as any).dataLayer = (window as any).dataLayer || []
    ;(window as any).dataLayer.push(args)
  }

  // Activer Google Analytics
  const activerAnalytics = () => {
    if (!(window as any).gtag) {
      const script = document.createElement('script')
      script.async = true
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-EG3YZVPXFW'
      document.head.appendChild(script)
      ;(window as any).dataLayer = (window as any).dataLayer || []
      ;(window as any).gtag = gtag
      gtag('js', new Date())
      gtag('config', 'G-EG3YZVPXFW')
    }
  }

  // Bouton Accepter tout
  const handleAcceptAll = () => {
    setCookie('voyo_cookies_essential', 'true', 365)
    setCookie('voyo_cookies_performance', 'true', 365)
    setCookie('voyo_cookies_advertising', 'true', 365)
    setCookie('voyo_cookies_decision', 'true', 365)
    setShowPopup(false)
    activerAnalytics()
  }

  // Bouton Refuser tout sauf essentiels
  const handleRefuseAll = () => {
    setCookie('voyo_cookies_essential', 'true', 365)
    setCookie('voyo_cookies_performance', 'false', 365)
    setCookie('voyo_cookies_advertising', 'false', 365)
    setCookie('voyo_cookies_decision', 'true', 365)
    setShowPopup(false)
  }

  // Ouvrir modal paramètres
  const handleOpenSettings = () => {
    setShowModal(true)
  }

  // Fermer modal
  const handleCloseModal = () => {
    setShowModal(false)
  }

  // Sauvegarder choix
  const handleSaveSettings = () => {
    setCookie('voyo_cookies_essential', 'true', 365)
    setCookie('voyo_cookies_performance', performanceChecked.toString(), 365)
    setCookie('voyo_cookies_advertising', advertisingChecked.toString(), 365)
    setCookie('voyo_cookies_decision', 'true', 365)
    setShowPopup(false)
    setShowModal(false)
    if (performanceChecked) {
      activerAnalytics()
    }
  }

  if (!showPopup) return null

  return (
    <>
      {/* POP-UP Voyo */}
      <div
        id='cookiePopup'
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          background: '#fff',
          borderRadius: '12px',
          boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
          padding: '20px',
          maxWidth: '400px',
          fontFamily: 'sans-serif',
          zIndex: 10000,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {/* Illustration oiseau */}
          <img
            src='https://i.imgur.com/3yXxk8N.png'
            alt='Oiseau Voyo'
            style={{ width: '50px', height: '50px', marginRight: '15px' }}
          />
          <div>
            <p style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#333' }}>
              Chez Voyo, nous utilisons des <b>cookies essentiels</b> pour garantir le bon
              fonctionnement du site. Vous pouvez choisir d&apos;accepter ou de refuser les autres
              types de cookies.
            </p>
            <button
              id='acceptCookies'
              onClick={handleAcceptAll}
              style={{
                background: '#4caf50',
                color: 'white',
                border: 'none',
                padding: '8px 12px',
                borderRadius: '5px',
                cursor: 'pointer',
                marginRight: '5px',
              }}
            >
              Accepter
            </button>
            <button
              id='refuseCookies'
              onClick={handleRefuseAll}
              style={{
                background: '#f44336',
                color: 'white',
                border: 'none',
                padding: '8px 12px',
                borderRadius: '5px',
                cursor: 'pointer',
                marginRight: '5px',
              }}
            >
              Refuser
            </button>
            <button
              id='cookieSettings'
              onClick={handleOpenSettings}
              style={{
                background: '#2196f3',
                color: 'white',
                border: 'none',
                padding: '8px 12px',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              Paramètres
            </button>
          </div>
        </div>
      </div>

      {/* Modal détails cookies */}
      {showModal && (
        <div
          id='cookieModal'
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: '#fff',
            padding: '20px',
            borderRadius: '12px',
            boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
            maxWidth: '400px',
            zIndex: 10001,
          }}
        >
          <h3>Gérer vos cookies</h3>
          <p>Cochez les types de cookies que vous souhaitez accepter :</p>
          <label style={{ display: 'block', marginBottom: '10px' }}>
            <input type='checkbox' id='essential' checked disabled style={{ marginRight: '8px' }} />
            Cookies essentiels (toujours actifs)
          </label>
          <label style={{ display: 'block', marginBottom: '10px' }}>
            <input
              type='checkbox'
              id='performance'
              checked={performanceChecked}
              onChange={(e) => setPerformanceChecked(e.target.checked)}
              style={{ marginRight: '8px' }}
            />
            Cookies de performance
          </label>
          <label style={{ display: 'block', marginBottom: '10px' }}>
            <input
              type='checkbox'
              id='advertising'
              checked={advertisingChecked}
              onChange={(e) => setAdvertisingChecked(e.target.checked)}
              style={{ marginRight: '8px' }}
            />
            Cookies de publicité
          </label>
          <br />
          <button
            id='saveCookies'
            onClick={handleSaveSettings}
            style={{
              background: '#4caf50',
              color: 'white',
              padding: '8px 16px',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              marginRight: '10px',
            }}
          >
            Enregistrer
          </button>
          <button
            id='closeModal'
            onClick={handleCloseModal}
            style={{
              background: '#f44336',
              color: 'white',
              padding: '8px 16px',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
            }}
          >
            Fermer
          </button>
        </div>
      )}
    </>
  )
}

export default CookiePopup
